import { api, downloadSkillZip } from "@/lib/api";

/**
 * Buy or download a skill. Skills are paid for with CREDITS (Phase 4c) — no Stripe redirect.
 * If already unlocked, downloads immediately; otherwise spends the skill's price and downloads.
 * Returns { action: 'downloaded' | 'purchased', balance }.
 * Throws an Error with `.code === 'insufficient_credits'` (and `.needed_cents`, `.balance`)
 * when the buyer can't afford it, so the caller can prompt a top-up.
 */
export async function purchaseOrDownload(skillId, slug) {
  let data;
  try {
    ({ data } = await api.post(`/skills/${skillId}/purchase`));
  } catch (e) {
    if (e?.response?.status === 402) {
      const d = e.response.data?.detail || {};
      const err = new Error("insufficient_credits");
      err.code = "insufficient_credits";
      err.needed_cents = d.needed_cents;
      err.balance = d.balance;
      throw err;
    }
    throw e;
  }
  await downloadSkillZip(skillId, slug);
  return { action: data.already_purchased ? "downloaded" : "purchased", balance: data.balance };
}

export function creditsLabel(cents) {
  if (cents == null) return "—";
  return `${(cents / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })} cr`;
}
